const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  status: "All",
  colors: [],
};

const filterSlice = createSlice({
  name: "todosFilter",
  initialState,
  reducers: {
    filterByStatus: (state, action) => {
      state.status = action.payload;
    },
    filterByColor: (state, action) => {
      state.status = "All";
      const { color, changeType } = action.payload;
      if (changeType === "added") {
        state.colors.push(color);
      }
      if (changeType === "removed") {
        state.colors = state.colors.filter(
          (existColor) => existColor !== color
        );
      }
    },
  },
});

export default filterSlice.reducer;
export const { filterByColor, filterByStatus } = filterSlice.actions;
